module.exports = __webpack_public_path__ + "img/cookie_dough.03fc96b3.jpg";